import React, { useState,useEffect } from "react";
import "./Login.css";
import gmail from "../../assets/google-svgrepo-com.svg";
import logo from "../../assets/flapone_logo_v4.png";
import loginimg from "../../assets/login.gif";
import { FaEye, FaEyeSlash  } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle.js";

import axios from "axios";
import SmallLoader from "../../components/SmallLoader";
import constant from "../../constant/constant";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/authSlice.js";
import { useNavigate } from "react-router-dom";
import {useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';

const Login = () => {
  const {id} = useParams();
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState("");
  const [gLoginUser, setGLoginUser] = useState([]); 
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  useTitle("Login - Access Your Account - Flapone Aviation");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "email") {
      setEmail(value);
    } else if (id === "password") {
      setPassword(value);
    }
  };
/*
useEffect(() => {
    if (user.auth_id !== null) {
      handleCheckLogin(user.auth_id);
    }
    if (id) {
    var getSavedLocalData = (localStorage.getItem('htloginDetails'));
      axios({
        method: "post",
        url: `${user.base_url}/autologin.php?fun=autologin`,
        headers: {},
        data: {
          id: id,
	      getSavedLocalData:getSavedLocalData,	
        },
      }).then(function (response) {
        if (response.data.login.status === 1) {
          const verifyUser = response.data;
          const redirectpage = verifyUser.data.logintype;
          const verifyDetail = verifyUser.login;

          if (redirectpage === "invitaion_descline") {
            navigate("/");
          } else {
            if (verifyDetail && verifyDetail.userid !== "") {
              // Dispatch the user data to Redux store
              dispatch(setUser(verifyDetail));
              localStorage.setItem(
                "htloginDetails",
                JSON.stringify(verifyDetail)
              );
              // Redirect to the desired page after successful login

              if (redirectpage === "email_verify") {
                navigate("/my-account");
              } else if (redirectpage === "forgot_password") {
                navigate("/my-account?tab=Settings&section=newpass");
              } else if (redirectpage === "invitaion_accept") {
                navigate("/my-account?tab=Settings");
              }else if(redirectpage=='buylead'){
                navigate("/");
              } else if(redirectpage){
		navigate("/"+redirectpage);
	      }
            }
          }
        } else {
          const verifyUser = response.data;
          if (verifyUser.data.logintype == "invitaion_descline") {
            const redirectpage = verifyUser.data.logintype;
            if (redirectpage === "invitaion_descline") {
              navigate("/");
            }
          }
        }
      });
    }

  }, [id]);

*/


  useEffect(()=>{
     const autoLoginAdmin = /^encriptid/;
    if(id) {
      axios({
        method: 'post',
        url: `${constant.base_url}/login_student.php?fun=autologin`,
        headers: {},
        data: {
          id:id,
          type:autoLoginAdmin.test(id)?'admin':'student',
        }
        }).then(function(response) {
        if(response.data.data.status === '1' || response.data.data.status === 1){
            const logdata  = response.data.login.data;
            const redirectpage = response.data.data.type;
            dispatch(setUser(logdata));
            setSuccess(response.data.data.msg);
            //localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(logdata))));
            const encodedLogData = btoa(encodeURIComponent(JSON.stringify(logdata)).replace(/%([0-9A-F]{2})/g,(match, p1) => String.fromCharCode(parseInt(p1, 16))));
            localStorage.setItem("flaponestudentlogdetails", btoa(encodedLogData));
            if(redirectpage === "forgot_password"){
                navigate("/my-account?tab=Settings&section=newpass");
              }else if(redirectpage === "email_verify"){
                navigate("/my-account?tab=settings");
              }else if(redirectpage === "invitaion_accept"){
                navigate("/my-account?tab=settings");
              }else{
              //navigate("/my-account");
              window.location.href = "/my-account";
              }
          }else{
            setShowError(response.data.msg);
        }
      });
  }
},[id]);

useEffect(()=>{
  handleCheckLogin(user.auth_id);
},[]);

function handleCheckLogin(auth_id) {
  axios({
    method: 'post',
    url: `${constant.base_url}/login_student.php?fun=checksessactive`,
    headers: {"Auth-Id": user.auth_id },
    data: {},
  }).then(function (response) {
    if (response.data && response.data.login.status && response.data.login.status === 1) {
      navigate("/my-account");
    }
  }).catch(function (error) {
    // Handle error, if necessary
    console.error("Error checking login:", error);
  });
}

const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    handleLogin(e);
  }
};
const handleLogin = async (e) => {
  e.preventDefault();
  setShowError("");
  setSuccess("");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) {
    setShowError("Email Empty!");
    return;
  }
  else if (!emailPattern.test(email)) {
    setShowError("Please enter a valid email address.");
    return;
  }  
  else if (!password) {
    setShowError("Password Empty!");
    return;
  }
   
  setLoading(true);
  axios({
    method: 'post',
    url: `${constant.base_url}/login_student.php?fun=login`,
    headers: {},
    data: {
      username: email,
      password: password,
      type:"student",
    }
  }).then(function(response) {
      const loginUser = response.data.login.data;
      if (loginUser && loginUser.user_id !== "" && loginUser.user_id!==undefined) {
          dispatch(setUser(loginUser));
          setSuccess(response.data.data.msg);
          localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(loginUser))));
          navigate("/my-account");
      }
     else{
      setShowError(response.data.data.msg);
     }
  }).catch(function(error) {
    // Handle errors
    console.error('Error during login:', error);
  });
  setLoading(false);

};


  /************************Google Login Code*******************************/

  const handleGoogleLoginSuccess = (codeResponse) => {
    // Set the gLoginUser state
    setGLoginUser(codeResponse);
    // Call the googleSignin function with the codeResponse
    googleSignin(codeResponse);
  };
  
  const login = useGoogleLogin({
    onSuccess:handleGoogleLoginSuccess,
    onError: (error) => console.log("Login Failed:", error),
  });
  function googleSignin(gLoginUser){
    if (gLoginUser) {
      axios.get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${gLoginUser.access_token}`, {
        headers: {
          Authorization: `Bearer ${gLoginUser.access_token}`,
          Accept: 'application/json',
        },
      })
      .then((res) => {
        createGoogleUser(gLoginUser, res.data);
      })
      .catch((err) => {
        console.error(err);
      });
    }
  }

  const createGoogleUser = async (gLoginUser, gLoginProfile) => {
    if (gLoginProfile) {
      setEmail(gLoginProfile.email);
    }
    axios({
      method: 'post',
      url: `${constant.base_url}/login_student.php?fun=loginbygoogle`,
      headers: {},
      data: {
        userdata: gLoginUser,
        userprofile: gLoginProfile,
        type:"student",
      }
    }).then(function(response){
        const loginUser = response.data.login.data;
        if (loginUser && loginUser.user_id !== "" && loginUser.user_id!==undefined) {
          dispatch(setUser(loginUser));
          setSuccess(response.data.data.msg);
          localStorage.setItem("flaponestudentlogdetails", btoa(btoa(JSON.stringify(loginUser))));
          navigate("/my-account");
        }
     else{
        setShowError(response.data.data.msg);
     }
    }).catch(function(error) {
      // Handle errors
      console.error('Error during login:', error);
    });
  };

  /****************************End Google Login Code*******************************/


  return (
    <div className="login-container df">
      <div className="left-side flx45">
        <div className="image-container pr w100">
          <img src={loginimg} alt="Login" className="image" />
          <div className="overlay-s box-center fc1 pa t0 b0 l0 r0 fdc tac jce">
            <p className="overlay-text fs18 pb24 lh22 ls1 fw6">
            After logging in, you'll benefit from:
            </p>
            <ul className="fc1 fs14 fw5 ls2 lh18 pb32 tal">
              <li className="v-center">
                <TiTick />Never miss a class! Stay informed of your upcoming classes and
                your attendance.
              </li>
              <li className="mt4 v-center">
              <TiTick />Get quick resolution to your concern by raising a service
                request.
              </li>
              <li className="mt4 v-center">
              <TiTick />Track your comprehensive performance across all assessments.
              </li>
            </ul>
            <p className="overlay-text fs14 pb32 lh22 ls1 tal">
            Explore your dashboard to make the most of these features and stay on top of your training.
            </p>
          </div>
        </div>
      </div>
      <div className="right-side bg1 df fdc  flx1">
        <div className=" box-center fdc  ">
          <div className="box-center w100 fdc mb12">
            <img src={logo} alt="logo" className="logo" />
            <div className="head-text mt24 mb16 box-center fdc">
              <p className="fs24 fc2 ls1 mb8">Welcome to the Flapone Family!</p>
              <p className="fs14 fc6">
                Sign in to explore your training resources and stay updated.
              </p>
            </div>
          </div>
          <form className="form-area">
            <label htmlFor="email" className="df fs16 ls1 fw6">
              Email<span className="fc5">*</span>
            </label>
            <input
              type="email"
              id="email"
              className="mb16"
              placeholder="Enter your email address"
              value={email}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
            />
            <label htmlFor="password" className="df fs16 ls1 fw6">
              Password<span className="fc5">*</span>
            </label>

            <div className="col-xl-12 pr mt4 password-input">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter password"
                value={password}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
              />
              <span onClick={togglePasswordVisibility}>
                {!showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="remember-forgot df jce fs12 ls1 fc1 cp">
              <Link to="/forgot-password">Forgot your password?</Link>
            </div>
            {showError && <div className="warn-msg box-center mb8 fs14 ls1 fc3 cp">
              {showError} 
            </div>}
            <button type="submit" className="h40 login-button bg3 fc1"  onClick={handleLogin}>
              {loading ? <SmallLoader/> : "Log in"}
            </button>
          </form>
          <div className="alternative-login box-center fdc form-area ">
            <p className="or-login-text fc6 fs14 box-center w100">
              Or, Login with
            </p>
            <button className="h40 google-login w100 fc2 box-center brd1 br4 cp bg1" onClick={(e) => {e.preventDefault();login();}}>
              <img src={gmail} className="mr8" alt="gmail" />
              Sign in with Google
            </button>
          </div>
          <div className="box-center w100 fs14 ls1">
            Don’t have an account?{" "}
            <span className="ml8 fc3 cp register">
              <Link to="/signup">Register here</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
